<template>
  <div>
      <PolygonOnBoarding v-if="showOnboarding"/>
      <section v-if="!isReadOnly && isEndCustomer && approvalStepsComponentData.length > 0" class="approval-section">
        <component class="task" v-for="(data, i) in approvalStepsComponentData" :args="data.args || {}" :is="data.key" :key="i" :index="i"></component>
      </section>
      <PolygonNextVisits :key="createKey('visit')" num-visits-to-show="3" class="mt-3"/>
      <PolygonProcess :key="createKey('accordion')" v-if="hasProcessStep"/>
      <div>
        <div class="grid mt-3">
          <div class="grid-item">
            <PolygonTechnician :key="currentErrand.project_manager"/>
          </div>
          <div class="grid-item">
            <PolygonChart v-if="currentErrand.features.useCostCalculations" :key="createKey('chart')" />
          </div>
        </div>
        <div>
          <PolygonTimeRemaining v-if="currentErrand.features.useEstimatedTimeFrames"/>
        </div>
      </div>
  </div>
</template>

<script>
import errandService from '@/core/services/errand-service'

export default {
  mounted() {
    this.hasFeature('useAddressSearch')
  },
  computed: {
    approvalStepsComponentData() {
      return errandService.getApprovalStepsComponentData()
    },
    showOnboarding() {
      return (
        !this.isReadOnly &&
        this.isEndCustomer &&
        !this.localErrand.onboardingCompleted
      )
    },
    hasProcessStep() {
      return !!errandService.getCurrentStep()
    }
  },
  methods: {
    createKey(prefix) {
      return `${prefix}_${this.currentErrand.request_id}`
    }
  }
}
</script>

<style lang="scss" scoped>
.approval-section {
  margin-bottom: measure(s);
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: measure(s);
  @media #{$mq-to-medium} {
    grid-template-columns: 1fr;
  }
}

.task {
  padding: measure(m) measure(s);
  background-color: color(primary);
  color: color(white);
  border-radius: $border-radius-box;
  @include font-size(s);
  margin-bottom: 1.5em;

  &:last-of-type {
    margin-bottom: 0;
  }

  a {
    color: color(white);
    font-weight: bold;
  }

  p {
    margin-top: 1.5em;
    margin-bottom: 1.5em;

    &:first-child {
      margin-top: 0;
    }
  }

  h2 {
    @include font-size(m);
    font-weight: 600;
    margin-bottom: 0.5em;
  }

  .label {
    display: inline-block;
    margin-bottom: measure(xxs);
    font-weight: $font-weight-medium;
  }

  .checkbox {
    @include font-size(xs);
  }
}

.task__button {
  text-align: center;
  margin-top: measure(m);
}

.task__link {
  text-decoration: underline;
}

.task__cost {
  display: inline-block;
  padding: measure(xxs) measure(l);
  background-color: color(primary-light);
  @include font-size(xxl);
  border-radius: $border-radius-box;
}
</style>
